import React, { useRef } from 'react';
import { Button, Form, Input, InputNumber, Modal, message } from 'antd';
import { reopenPost } from '@/apis/posts';
import usePrivateAction from '@/utils/usePrivateAction';
import { logicalRequest } from '@/utils/logicalRequest';

const ReopenPost = ({ post, onCancel, onSaved }) => {
  const { busy, run } = usePrivateAction(); const requestRef = useRef(null);
  const submit = values => run(() => reopenPost(post.id, logicalRequest(requestRef, {
    expire_time: new Date(values.expire_time).toISOString(), recruitment_count: values.recruitment_count,
  })), async () => { message.success('招募已重新开放'); await onSaved(); }, '重新开放失败，请重试');
  return <Modal title="重新开放招募" open onCancel={() => !busy && onCancel()} footer={null} closable={!busy} mask={{ closable: !busy }}>
    <p>保留已有申请和群成员。已完成活动或已解散群聊不能重新开放。</p>
    <Form name={`reopen-post-${post.id}`} layout="vertical" disabled={busy} initialValues={{ recruitment_count: post.max_participants || 1 }} onFinish={submit}>
      <Form.Item name="expire_time" label="新的截止时间" rules={[{ required: true, message: '请选择截止时间' }, { validator: (_, value) => !value || Date.parse(value) > Date.now() ? Promise.resolve() : Promise.reject(new Error('截止时间必须晚于当前时间')) }]}><Input type="datetime-local" /></Form.Item>
      <Form.Item name="recruitment_count" label="招募人数" extra="人数须大于当前已加入的人数，才能继续招募。" rules={[{ required: true, message: '请填写招募人数' }, { validator: (_, value) => value > (post.approved_participant_count || 0) ? Promise.resolve() : Promise.reject(new Error('请增加招募人数，为新伙伴留出名额')) }]}><InputNumber min={1} max={32767} precision={0} /></Form.Item>
      <Button type="primary" htmlType="submit" loading={busy}>重新开放招募</Button>
    </Form>
  </Modal>;
};
export default ReopenPost;
